module.exports = {
  width: 250,
  height: 150,
  bytes: 1913,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};